import React from "react";
import classNames from "classnames";
import { compose } from "redux";

import connectProps from "shared/lib/connectProps";
import connectActions from "fantastic/lib/connectActions";
import PublishMyTemplate from "shared/components/buttons/PublishMyTemplate";
import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

const NextStepButton = (props) => {
  const {
    settings: {
      next_url ,
      save_as_template_url,
      standalone_mode,
      template_active
    },
    app: { savingInProgress = false, errorOnSaving = false, necessitySaving = false },
    retryAction
  } = props;

  const canPublish = standalone_mode && !template_active;

  const buttonClasses = classNames(
    'btn btn-success btn-block', {
      disabled: necessitySaving || savingInProgress
    }
  );

  const handleRetry = (e) => {
    e.preventDefault();

    retryAction();
    return false;
  }

  const retryButton = () => {
    return <a className="btn btn-danger btn-block" onClick={ handleRetry }>{ i18n.t('header.retry') }</a>
  }

  const renderButton = () => {
    if(errorOnSaving) return retryButton();
    return (
      <>
      { canPublish ? (
        <PublishMyTemplate save_as_template_url={save_as_template_url} classes={buttonClasses} />
      ) : (
        next_url && <a href={next_url} className={buttonClasses}>
          { savingInProgress ? i18n.t(`header.loading.${savingInProgress}`) : i18n.t('header.next')  }
        </a>
      ) }
      { savingInProgress == 'progress' && <div className="fantastic-header__loading" /> }
      </>
    );
  }

  return (
    <div className="fantastic-header__nextstep">{renderButton()}</div>
  )
}

export default compose(
  connectProps("app", "settings"),
  connectActions({
    retryAction: () => (dispatch, getState) => debouncedSaveTemplate(dispatch, getState)
  })
)(NextStepButton);
